export { default as LoginManager } from './biz/login';
export { default as RoleSelector } from './biz/roleselector';
export { default as BindArea } from './biz/bindArea';
export { default as getGift } from './biz/lottery/getGift';
export { default as Broadcast } from './biz/lottery/broadcast';
export { default as MyGiftList } from './biz/lottery/myGiftList';
export { default as getPersonInfo } from './biz/lottery/personalInfo';
export { default as CheckIn } from './biz/checkin';
export { default as Cdk } from './biz/cdkey';
export { default as Customize } from './biz/customize';
export { default as miloCore } from './common/milo';
export { default as mobileShare } from './biz/mobileShare';
export { default as pcShare } from './biz/pcShare';
export { default as miloJsBridge } from './biz/jsBridge';
export { default as iosInstallReport } from './biz/iosInstallReport';
export { default as milo } from './compat/milo';
export { default as miloMobile } from './compat/miloMobile';
export { default as ATM } from './util/atm';
export { default as FrontMonitor } from './biz/frontMonitor';
export { default as DJCPay } from './biz/djc';
export { default as DOUYIN } from './biz/douyin';
export { default as jump } from './biz/jump';
export { default as Base64 } from "./util/base64";
import pkg from "../package.json";

if (pkg) {
  try {
    window.MiloCoreVersion = pkg.version;
    console.log("%c milo-core %c \u7248\u672C\uFF1A".concat(pkg.version, " "), 'background: #35495e; padding: 4px; border-radius: 3px 0 0 3px; color: #fff', 'background: #7bbfea; padding: 4px; border-radius: 0 3px 3px 0; color: #fff');
  } catch (err) {
    console.log("milo-core \u7248\u672C\uFF1A".concat(pkg.version));
  }
}